import React, { Component } from "react"
//import { createSnapshot } from "../Tree/Utils.js"
import { snapshotOptions } from '../../variables/ComboValues'
import { FamilyImproveDetails } from './FamilyImproveDetails'

export const countStotal = (d) => d === undefined || d === null || d === false ? 0 : d.length

export class FamilyImprove extends Component {
    // this.props.data contains array of snapshots
    constructor(props){
        super(props)
        //const sTotal = this.props.data === null ? 0 : this.props.data.length
        const sTotal = countStotal(this.props.data)

        this.state={
            filterText : "",
            snap:  {
              from: sTotal ? snapshotOptions[0] : 'עכשיו',
              to: sTotal > 1 ? snapshotOptions[1] : 'עכשיו'
            },
            dFrom:[], dTo:[],
            display: '' // 'snapshot' || 'compare'
        }
        this._isMounted = false
        this.setSnapsots = this.setSnapsots.bind(this) 
        this.doCompare = this.doCompare.bind(this) 
    }

    // set the selection initial values
    componentDidMount(){
      this._isMounted = true
    }

    componentWillUnmount(){
      this._isMounted = false
    }


    // select option value set
    setSnapsots(evt,el){
      evt.preventDefault()
    //  console.log("setSnapsots evt=", evt)
      if (this.state.snap[el] !== evt.target.value){ // ignore
        let newState = Object.assign(this.state.snap)
        newState[el] = evt.target.value
        this.setState({snap: newState, display:''})
      }
    }

    // request compare button - set the component mode
    doCompare(evt){
      //console.log("setSnapsots evt=", evt)
      evt.preventDefault()
      //console.log("doCompare clicked", this.state)
      const {snap} = this.state
      const dFrom = Object.assign(this.props.acf)
////console.log("doCompare acf=", this.props.acf)

      if (snap.from === snap.to){
        this.setState({display:'snapshot', dFrom: dFrom, dTo:dFrom})
        return null
      }
      if (dFrom.snapshots.length > 0 && snap.to === 'עכשיו' ){ //snap['to'].localeCompare('עכשיו')) // instead of === 'עכשיו')
        this.setState({display:'compare', dFrom: dFrom, dTo:this.props.acf})
        return null
      }
      if (snap.to !== 'עכשיו' && snapshotOptions.indexOf(snap.from) >= snapshotOptions.indexOf(snap.to)){
        console.log("Cannot compare from="+ snap.from + "   against= "+ snap.to)
        return null
      }
      this.setState({display:'compare', dFrom: dFrom, dTo: this.props.acf}) // Should BRING the target !!!! dTo was dFrom ???
      return null
    }

    // TODO - a component to share with compare snapshot and display improvement
    displayCompareSnapshot = () =>{
      const options= snapshotOptions // ['התחלה','מחצית','סיום']
      const buttonStyle = {marginRight: '10px'}
      //const sTotal = this.props.data === null ? 0 : this.props.data.length
      const sTotal = countStotal(this.props.data)

        return (
            <div style={{width: '40%'}}>
              <p className="float-right margin-left10" >מדידה בין תמונות מצב</p>
              { ['from','to'].map((el, index) => {
                if (el === 'to' && sTotal === 0) 
                  return null // nothing to compare to
                return(
                    <select key={el} style={{width: '22%', marginLeft:'5px'}} name={'scompare-'+el} 
                      id={'scompare-'+index} 
                      value={this.state.snap[el]} 
                      onChange={ event => this.setSnapsots(event, el)} > 
                        {options.map((item, innerIndex) => {
                          if (el === 'from' && innerIndex >= options.length-1) return null // do not show last option
                          if (el === 'to' && innerIndex === 0 ) return null // do not show first option
                          let disabled = false
                          //if (nowOn) return null
                          if (el === 'from' && sTotal === 0){ // only now to display
                            if (innerIndex > 0) return null // allow only one occurrance of now
                            const litem = 'עכשיו'
                            return <option key={litem} value={litem}>{litem}</option>
                          }
                          if (el === 'to' && sTotal === 1){
                            if (innerIndex > 1) return null // allow only one occurrance of now
                            const litem = 'עכשיו'
                            return <option key={litem} value={litem}>{litem}</option>
                          }
                          if (innerIndex >= sTotal) return null
                          // disabled = (el === 'to' && this.state.snap['from'] > innerIndex) // set disabled
                          return <option key={item} disabled={disabled} value={item}>{item}</option>}
                        )}
                        {
                          (el === 'to' && sTotal > 0)? // now as target option
                            <option key={'עכשיו'} value={'עכשיו'}>{'עכשיו'}</option> : null
                        }
                        }
                    </select>)
                })
              }
              <button style={buttonStyle} type="button" onClick={event => this.doCompare(event) }
                                          className="btn btn-success pull-left" > {"הצג נתונים"}  </button>
            </div>
        )
    }

    render() {
      //const sTotal = this.props.data === null ? 0 : this.props.data.length
      const { snap } = this.state
      if (this.props.acf === undefined) return null
      // console.log('snapshot render acf', this.props.acf)
      ////console.log("setSnapsots snap=", snap)

      return (
        <div className="yahav-modal">
          <h2>{this.props.tableTitle}</h2>
          {this.displayCompareSnapshot()}
          {this.state.display && <FamilyImproveDetails snap={snap} now={this.props.acf} cpt={this.props.cpt} /> }
        </div>
      )
    }
  }
  